import React, { useState } from "react";
import {
  Button,
  Popover,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const HoverCardWithLegend = ({
  triggerLabel,
  legendItems,
  cardWidth = 187,
  buttonHeight = 40,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Button
        aria-owns={open ? "hover-popover" : undefined}
        aria-haspopup="true"
        variant="outlined"
        onClick={handlePopoverOpen}
        sx={{
          padding: (theme) => theme.spacing(0.5, 4),
          borderRadius: (theme) => theme.shape.xxs,
          height: buttonHeight,
        }}
      >
        
        {triggerLabel}
      </Button>
      <Popover
        id="hover-popover"
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        sx={{
          // width: cardWidth,
          padding: "16px 0px 0px 0px",
          gap: "16px",
          border: "1px solid transparent",
        }}
      >
        <Card>
          <CardContent>
            <Box mt={2}>
              <Box>
                {legendItems.map((item, index) => {
                  const backgroundColor = theme.palette[item.boxshadow]
                    ? theme.palette[item.boxshadow].main
                    : item.boxshadow;

                  return (
                    <Box key={index} display="flex" alignItems="center" mb={1}>
                      <Box
                        sx={{
                          position: "relative",
                          // width: "100%",
                          minWidth: 30,
                          height: 24,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: item.boxcolor,
                          boxShadow: `0px 1.41px 4px 0px ${backgroundColor}`,
                          marginRight: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            color: item.color,
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontWeight: 600,
                            fontSize: 12,
                            lineHeight: "18px",
                          }}
                        >
                          {item.letter}
                        </Typography>
                      </Box>
                      <Typography
                        variant="caption"
                        fontWeight={600}
                        fontSize={12}
                        lineHeight={"18px"}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Popover>
    </div>
  );
};

export default HoverCardWithLegend;
